<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .TCPHead{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 5px 10px #707070;
    position: relative;
    z-index: 98;
  }
  .TCPHead .TCPnav{
    overflow: hidden;
    width: 1200px;
    height: 42px;
    margin: 0 auto;
  }
  .TCPHead .Logo{
    /*background:url(../assets/img/logo.png)no-repeat;*/
    /*width: 92px;*/
    /*height: 76px;*/
    position: absolute;
    cursor: pointer;
    z-index: 99;
    line-height: 42px;
  }
</style>
<template>
  <div class="TCPHead">
    <div class="TCPnav">
      <div class="Logo" @click="HomeFun()">返回MATCHON首页</div>

    </div>
    <!--<mylogin v-if="myloginBl" v-bind:isLogo="isLogo" v-on:booler="boolerFun"></mylogin>-->
    <!--<myregistered v-if="myregisteredBl" v-bind:isReg="isReg" v-on:booler="boolerFun"></myregistered>-->
  </div>
</template>

<script>
//  import mylogin from './IsLogin.vue'
//  import myregistered from './IsRegistered.vue'
  export default {
    name: 'Head',
    components: {
//      mylogin,
//      myregistered
    },
    data () {
      return {

      }
    },
    computed:{

    },
    mounted(){

    },
    methods:{
      HomeFun(){
        window.document.location.href="http://www.matchon.net/index/home"
      },
    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Head.vue